import { render, staticRenderFns } from "./AnalysisMaterialComments.vue?vue&type=template&id=1bc925dc&scoped=true"
import script from "./AnalysisMaterialComments.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisMaterialComments.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnalysisMaterialComments.vue?vue&type=style&index=0&id=1bc925dc&prod&lang=scss&scoped=true"
import style1 from "./AnalysisMaterialComments.vue?vue&type=style&index=1&id=1bc925dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc925dc",
  null
  
)

export default component.exports